/**
 * NoteEvaluationEnum is used to indicate correct, incorrect, and close
 */
export enum NoteScores {
  correct,
  incorrect,
  close,
}